import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { STATUS_SUCCESS_CODE,GENERATE_OTP, ADD_RPPS_BILLERS, GET_MY_BILL_PAYMENTS, GET_FREQUENCIES, BILL_PAYMENTS_META_DATA, GET_ACCOUNTS_FOR_TRANSFER, GET_MASTER_BILLERS, BILLER_COUNTRIES, BILLERE_STATES, ADD_PAPER_BILLER, GET_BILLER_DETAILS, REMOVE_BILLERE, SCHEDULED_BILLERS_LIST, SCHEDULED_DETAILES, CANCEL_PAYMENT, PAYMENT_HISTORY, BILL_PAYMENTS_OVERVIEW } from '../../../../../network/URLConstants';
import { useDispatch, useSelector } from 'react-redux';
import { appTheme, retrieveData } from '../../../../../helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest } from '../../../../../network/NetworkUtils';
import { withOidcSecure } from '@axa-fr/react-oidc';
import HomeLayout from '../../../../Layout/HomeLayout';
import HomeHeader from '../../../../CustomComponents/HomeHeader';
import DynamicCard from '../../../../CustomComponents/DynamicCard';
import { width, height } from '../../../../CustomComponents/DynamicCard/DynamicCardStyles';
import { useLocation, useNavigate } from 'react-router-dom';
import CardHeading from '../../../../CustomComponents/CardHeading';
import { addLineBreaks } from '../../../../../utils';
import CustomTextInput from '../../../../CustomComponents/CustomtextInput';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { displayErrorMessage, displayErrorMessageSCHSSN } from '../../../../../utils';
import { PostRequest } from '../../../../../network/NetworkUtils';
import Modal from '../../../../CustomComponents/Modal';
import Loader from '../../../../CustomComponents/Loader';
import { validateMobileNumberForSCH } from '../../../../../utils';
import CustomDropdown from '../../../../CustomComponents/CustomDropDown';
import { isEmailValid } from '../../../../../utils';
import HideSSNPic from '../../../../../assets/images/hidepassword.png'
import { set } from 'react-hook-form';
import { formatDateOfBirthForUi, formatDateToDDMMYYYYFORSCH } from '../../../../../helpers/utils/Utils';
import { formatDateYYYYMMDD, formatDateYYYYMMDDFORSCH, formatDateToMMDDYYYY } from '../../../../../utils';
import { personalFormatPhoneNumber } from '../../../../../utils';
import { displayKudzuplusErrorMessage } from '../../../../../utils';
import { LOGIN_SESSION_KEY } from '../../../../../Redux/reducers';
import Check from '../../../../../assets/images/Check.png'
import { Tabs, Tab } from '../../../../CustomComponents/TabsComponent';
import FilterSlider from 'components/CustomComponents/Slider';
import logFirebaseEvents from 'components/LogFirebaseEvents';
import BillersData from './BillersData';
import AddBiller from './AddBiller';
import AddBillersSuccessModal from './AddBillersSuccessModal';
import ErrorModal from './ErrorModal';
import AddNewBiller from './AddNewBiller';
import BillerDetails from './BillerDetails';
import RemoveBiller from './RemoveBiller';
import ModifyBiller from './ModifyBiller';
import ScheduleBillersData from './ScheduleBillersData';
import ScheduleBillerDetails from './ScheduleBillerDetails';
import PaymentHistoryData from './PaymentHistoryData';
import TwoFactTypeSelctionModal from 'components/CustomComponents/TwoFactTypeSelctionModal';
import Custom2FA from 'components/CustomComponents/Custom2FA';
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle';

const BillPayments = () => {
    const { t } = useTranslation();
    
    useDocumentTitle(t('page_title_bill_payments'));

   
    const navigate = useNavigate();
    const cards = useSelector(state => JSON.parse(state.userCards));
    const dispatch = useDispatch()
    const currentpath = useLocation()
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)
    const InputStyles = "font-hanken-grotesk px-4 lg:text-[16px] md:text-[15px] text-[14px] placeholder:font-semibold font-medium focus:outline-none w-full h-[60px]";
    const selectedItem = cards?.find(card => card.AccountTypeBit63 === 1);
    const accessToken = useSelector((state) => state.accessToken);
    const [isLoading, setIsLoading] = useState(false);
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const HeadingStyles =
        "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--oops-edit-clr)]";
    const SubHeadingStyles =
        "font-serif-pro modal-title lg:text-[33px] md:text-[33px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--modal-edit-spendsense)] md:w-[80%]";
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
    const CardButton = 'w-[48%] h-[40px] text-[var(--btn-text-mobile)] bg-[var(--btn-bg-mobile)] font-hanken-grotesk lg:text-[16px] md:text-[14px] sm:text-[11px] md:leading-[39.71px] sm:leading-[25.8px] md:h-[50px] sm:h-[35px] inline-block rounded-full border-[3px] border-[var(--btn-bg-mobile)] text-xs font-semibold leading-normal transition duration-150 ease-in-out';
    
    const footerStyles = "underline font-hanken-grotesk cursor-pointer text-center pt-8 text-[var(--text-clr-transactions-viewall)] font-bold lg:text-[18px] md:text-[17px] sm:text-[14px] text-[14px] leading-[18px] absolute md:bottom-24 bottom-[3rem] left-1/2 -translate-x-1/2 cursor-pointer w-full";
    const footerStylesNoRecords = "font-hanken-grotesk text-center cursor-pointer pt-24 font-[500] md:font-[500]  lg:text-[18px] md:text-[18px] mb-[200px] sm:text-[12px] text-[14px] leading-[18px] opacity-[75%] w-full";
    const BILL_TAB_PAYEES = t("BILL_PAYMENTS_PAYEES");
    const BILL_TAB_SCHEDULE = t("BILL_PAYMENTS_SCHEDULE");
    const BILL_TAB_HISTORY = t("BILL_PAYMENTS_HISTORY");
    const [activeBillTab, setActiveBillTab] = useState(BILL_TAB_PAYEES);
    const [showFilterOverlay, setShowFilterOverlay] = useState(false);
    const [isHideSearchAndFilterBtn, setIsHideSearchAndFilterBtn] = useState(true)
    const [myBiillersData, setMyBillersData] = useState([])
    const [scheduleBillersList , setScheduleBillersList] = useState([])
    const [paymentHistoryList , setPaymentHistoryList] = useState([])
    const [overviewResp , setOverViewResp] = useState()
      const [modifyBillerType, setModifyBillerType] = useState(null)
      const [billerTypeForDetails , seBillerTypeForDetails] = useState(null)
      const [billPaymentFeeMessage , setBillPaymentFeeMessage]= useState()


    // component states
    const [isShowIntialListsCard, setIsShowInitialListsCard] = useState(true)
    const [isAddBillerComponentOpen, setIsAddBillerComponent] = useState(false)
    const [isOpenAddBillerInfo, setIsAddBillerInfo] = useState(false)
    const [isOpenAddNewBiller, setisOpenAddNewBiller] = useState(false)
    const [isOpenAddNewBillerSubmit , setIsOpenAddNewBillerSubmit] = useState(false)
    const [myBillerDetails , setMyBillersDetails] = useState(false)
    const [isOpenModifyBiller , setIsOpenModifyBiller] = useState(false)
    const [isOpenModifyBillerSubmit , setIsOpenModifyBillerSubmit] = useState(false)
    const [isOpenScheduleDetails, setIsOpenScheduleDetails] = useState(false)
    // component states end here
    const billerKey = useSelector (con => con.removeBillerId)
    const cancelPaymentKey = useSelector( con => con.cancelPaymentId)
    const [frequency, setFrequency] = useState([])
    const selectedBiller = useSelector(con => con.selectedBillerType);
    const enteredAccountNumber = useSelector(con => con.enteredAccountNumber);
    const reEnteredAccNumber = useSelector(con => con.reEnteredAccNumber);
    const selectedFrequencyType = useSelector(con => con.selectedFrequencyType);
    const billAmount = useSelector(con => con.billAmount);
    const billPaymentOneTimeDate = useSelector(con => con.billPaymentOneTimeDate);
    const billPaymenRCStartDate = useSelector(con => con.billPaymenRCStartDate);
    const billPaymenRCEndDate = useSelector(con => con.billPaymenRCEndDate);
    const [addBillerSuccessModal, setAddBillerSuccessModal] = useState(false)
    const [removeBillerSucessOpen, setRemoveBillerSuccessOpen] = useState(false)
    const [cancelPaymentSuccessModal , setCancelPaymentSuccessModal] = useState(false)
    const [errorModal, setErrorModal] = useState(false)
    const [apiErrMsg, setApiErrMsg] = useState("")
    const [countries , setCountries] = useState([])
    const [states , setStates] = useState([])
    const [billereDetailsResp , setBillerDetailsResp] = useState()
    const [scheduleBillersDetailsResp , setScheduleBillersDetailsResp] = useState()
    const [removeBillerConfirm , setRemoveBillerConfirm] = useState(false)
    const [removeBillerSuccess , setRemoveBillerSuccess] = useState(false)
    const [removeScheduleBiller, setRemoveScheduleBiller] = useState(false)
    const [billereRemoveId , setBillerRemoveId] = useState()
    const [modifySuccessBillerOpen , setModifyBillerSuccessOpen] = useState(false)

    //new biller redux states
    const newBillerName = useSelector(con => con.newBillerName);
    const newAccountNumber = useSelector(con => con.newAccountNumber);
    const billerAddressOne = useSelector(con => con.billerAddressOne);
    const billerAddressTwo = useSelector(con => con.billerAddressTwo);
    const billerAddressCity = useSelector(con => con.billerAddressCity);
    const billerAddressZipCode = useSelector(con => con.billerAddressZipCode);
    const billerAddressStates = useSelector(con => con.billerAddressStates);
    const billerAddressCuntries = useSelector(con => con.billerAddressCuntries);
    const billerAddressPhone = useSelector(con => con.billerAddressPhone);
    const newBillerFrequency = useSelector(con => con.newBillerFrequency);
    const newBillerOneTimeDate = useSelector(con => con.newBillerOneTimeDate);
    const newBillerRcStartDate = useSelector(con => con.newBillerRcStartDate);
    const newBillerRcEndDate = useSelector(con => con.newBillerRcEndDate);
    const newBillerAmount = useSelector(con => con.newBillerAmount);

    // modify biller redux states
    const modifyBillerName = useSelector(s => s.modifyBillerName);
    const modifyAccNumber = useSelector(s => s.modifyAccNumber);
    const modifyLine1 = useSelector(s => s.modifyLine1);
    const modifyLine2 = useSelector(s => s.modifyLine2);
    const modifyCity = useSelector(s => s.modifyCity);
    const modifyStates = useSelector(s => s.modifyStates);
    const modifyZipCode = useSelector(s => s.modifyZipCode);
    const modifyCountry = useSelector(s => s.modifyCountry);
    const modifyPhone = useSelector(s => s.modifyPhone);
    const modifyFrequency = useSelector(s => s.modifyFrequency);
    const modifyAmount = useSelector(s => s.modifyAmount);
    const modifyOneTimeDate = useSelector(s => s.modifyOneTimeDate);
    const modifyStartDate = useSelector(s => s.modifyStartDate);
    const modifyEndDate = useSelector(s => s.modifyEndDate);
    const modifySVAKey = useSelector(x => x.modifySvaBillerKey)
    const modifyBillerId = useSelector(x => x.modifyBillerID)



        // Pager + view-more state for Schedule/History footer
    const [schedulePager, setSchedulePager] = useState(null)
    const [historyPager, setHistoryPager] = useState(null)


    // generate and verify OTP flow 
    const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
    const [show2faSelection, setshow2faSelection] = useState(false);
    const [selectedOtpType, setSelectedOtpType] = useState('');
    const [slectedFieldToEdit, setSlectedFieldToEdit] = useState('');
    const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
    const [twoFactModelTitle, setTwoFactModelTitle] = useState('');
    const [twoFactModelSubTitle, setTwoFactModelSubTitle] = useState('');
    const [showStnadradRatesMessage, setShowStnadradRatesMessage] = useState(false);
    const [bottomTextValue , setBottomTextValue] = useState(false)
    const [selectedType, setSelectedType] = useState('');


    const closeOTPVerifyModal = () => { 
        setIsOTPVerifyModalOpen(false) 
    }


    const verificationFaiure = (type, verifyResponse) => {
        var arrMessages = verifyResponse.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        setErrorModal(true)
        setApiErrMsg(displayText);
    }


    const verificationSuccess = (type, verifyResponse) => {
        handleBillPaymentsTabChange(BILL_TAB_PAYEES)
        fetchOverview()
        if (type == t('rpps_biller')) {
            setAddBillerSuccessModal(true);
            setIsAddBillerComponent(false)
            setIsAddBillerInfo(false)
            setIsShowInitialListsCard(true)
        }
        else if (type == t('paper_biller')) {
            setAddBillerSuccessModal(true)
            setIsShowInitialListsCard(true)
            setisOpenAddNewBiller(false)
            setIsOpenAddNewBillerSubmit(false)
        } else if (type == t('modify_paper') || type == t('modify_rpps'))
        {
            setModifyBillerSuccessOpen(true)
        }
    }

      // If modify submit is clicked and 2FA is not yet done, open 2FA selection
    // and mark that the pending action is "modify biller".
    const handleRequireModifyBiller2FA = (isPaperBiller) => {
        const billerType = isPaperBiller ? t('modify_paper') : t('modify_rpps')
        setSlectedFieldToEdit(billerType)
        setSelectedType(billerType)
        setshow2faSelection(true)
    }



    const generate2FAOtp = async (type, procType) => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);

        let request 
        switch (slectedFieldToEdit){
          case t('rpps_biller'):
          request ={
             "SessionKey": 0,
             "ActionType": slectedFieldToEdit === t('rpps_biller') ? "AddRPPSBiller" :"AddPaperBiller",
             "Biller": {
                "BillerID": selectedBiller?.Type,
                "BillerName": selectedBiller?.Name,
                "AccountNumber": enteredAccountNumber,
                "ReferenceName": "",
                "FrequencyType": selectedFrequencyType?.Type,
                "NextDate": selectedFrequencyType?.Type === "O" ? formatDateYYYYMMDDFORSCH(billPaymentOneTimeDate) : formatDateYYYYMMDDFORSCH(billPaymenRCStartDate),
                "EndDate": selectedFrequencyType?.Type === "O" ? formatDateYYYYMMDDFORSCH(billPaymentOneTimeDate) : formatDateYYYYMMDDFORSCH(billPaymenRCEndDate),
                "Amount": billAmount
            }
          };
          break;
          case t('paper_biller'):
                request = {
                    "SessionKey": 0,
                    "ActionType": "AddPaperBiller",
                    "Biller": {
                        "BillerName": newBillerName,
                        "AccountNumber": newAccountNumber,
                        "Amount": newBillerAmount,
                        "NextDate": newBillerFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(newBillerOneTimeDate) : formatDateYYYYMMDDFORSCH(newBillerRcStartDate),
                        "EndDate": newBillerFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(newBillerOneTimeDate) : formatDateYYYYMMDDFORSCH(newBillerRcEndDate),
                        "FrequencyType": newBillerFrequency?.Type,
                        "Line1": billerAddressOne,
                        "Line2": billerAddressTwo,
                        "City": billerAddressCity,
                        "StateCode": billerAddressStates?.Type,
                        "CountryCode": billerAddressCuntries?.Type,
                        "ZipCode": billerAddressZipCode,
                        "PhoneNumber": billerAddressPhone
                    }

                };
                break;
            case t('modify_paper'):
                request = {
                    "SessionKey": 0,
                    "ActionType": "ModifyPaperBiller",
                    "Biller": {
                        "AccountNumber": modifyAccNumber,
                        "Amount": modifyAmount,
                        "BillerName": modifyBillerName,
                        "City": modifyCity,
                        "CountryCode": modifyCountry?.Type,
                        "FrequencyType": modifyFrequency?.Type,
                        "Line1": modifyLine1,
                        "Line2": modifyLine2,
                        "PhoneNumber": modifyPhone,
                        "SVABillerKey": modifySVAKey,
                        "BillerID": "",
                        "StateCode": modifyStates?.Type,
                        "ZipCode": modifyZipCode,
                        "NextDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyStartDate),
                        "EndDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyEndDate),
                    }

                };
                break;
            case t('modify_rpps'):
                request = {
                    "SessionKey": 0,
                    "ActionType": "ModifyRPPSBiller",
                    "Biller": {
                        "AccountNumber": modifyAccNumber,
                        "Amount": modifyAmount,
                        "BillerName": modifyBillerName,
                        "FrequencyType": modifyFrequency?.Type,
                        "SVABillerKey": modifySVAKey,
                        "BillerID":  modifyBillerId,
                        "NextDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyStartDate),
                        "EndDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyEndDate),
                    }
                };
                break;
        }

        let url
        switch (slectedFieldToEdit) {
            case t('rpps_biller'):
                url = GENERATE_OTP + "?CardKey=" + selectedItem?.CardKey;
                break;
            case t('paper_biller'):
                url = GENERATE_OTP + "?CardKey=" + selectedItem?.CardKey;
                break;
            case t('modify_paper')  :
               url = GENERATE_OTP + "?CardKey=" + selectedItem?.CardKey;
               break; 
            case t('modify_rpps')  :
               url = GENERATE_OTP + "?CardKey=" + selectedItem?.CardKey;
               break; 
        }
        setIsLoading(true);
        try {
            const response = await PostRequest(url, request, headers);
            setIsLoading(false);
            const parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode === STATUS_SUCCESS_CODE) {
                //adding sessionid to redux
                // const loginSessionPayLoad = { loggedSessionKey: parsedResponse.Response.sessionId }
                // dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });


                const loginSessionPayLoad = { loggedSessionKey: parsedResponse.Response.SessionKey }
                dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });


                //adding userid to redux
                const userIdPayload = { userId: parsedResponse.Response.userId }
                dispatch({ type: 'USER_ID', payload: userIdPayload });
                setTimeout(() => {
                    setTwoFactModelTitle(show2faSelection == true ? t('great_exclamation') : t('security_check'));
                    setTwoFactModelSubTitle(procType != 'Email' ? t('we_are_sending_messsage') : t('we_are_sending_email_message'));
                    setShowStnadradRatesMessage(procType != 'Email' ? true : false)
                    setBottomTextValue(false)
                    setIsOTPVerifyModalOpen(true);
                }, 1000);


            } else {
                const arrMessages = parsedResponse.Messages;
                const message = arrMessages[0];
                const displayText = message.DisplayText;
                setApiErrMsg(displayText)
                setErrorModal(true)
            }
        } catch (error) {
        }
    };
 



    const Footer = () => {
        const historyTotal = Number(historyPager?.TotalItems ?? 0)
        const scheduleTotal = Number(schedulePager?.TotalItems ?? 0)
        const r = Number(rows)
        const showHistoryFooter =
            activeBillTab === BILL_TAB_HISTORY && historyTotal > r
        const showScheduleFooter =
            activeBillTab === BILL_TAB_SCHEDULE && scheduleTotal > r
        if (!showHistoryFooter && !showScheduleFooter) return null
        return (
            <div>
                <div
                    className={footerStyles}
                    onClick={
                        showScheduleFooter
                            ? handleScheduleViewMore
                            : handleHistoryViewMore
                    }
                >
                    {t('viewAll')}
                </div>
            </div>
        )
    };




     // Initial pagination values from URL query (example: ?rows=10&page=1)
    const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams()
    const getQP = (key, fallback) => urlParams.get(key) ?? fallback
    const initialRowsPerPage = Number(getQP('rows', '10')) || 10
    const initialPage = Number(getQP('page', '1')) || 1
    const [rows, setRowsPerPage] = useState(initialRowsPerPage)
    const [page, setPage] = useState(initialPage)



    const getInitialFilterOverrides = () => ({
        rows: initialRowsPerPage,
        page: initialPage,
    })


    const handleResetFilters = () => {
        const defaults = getInitialFilterOverrides()
        setRowsPerPage(defaults.rows)
        setPage(defaults.page)


        setShowFilterOverlay(false)
        setIsHideSearchAndFilterBtn(true)
    }



    const handleApplyFilters = (appliedFiltersObj) => {
        // Filters removed: keep only pagination (rows + page)
        setPage(1)
        setRowsPerPage(initialRowsPerPage)


        const overrides = {
            page: 1,
            rows: initialRowsPerPage,
        }


        if (activeBillTab === BILL_TAB_SCHEDULE) {
            fetchScheduledBillersData(selectedItem?.CardKey, overrides)
        } else if (activeBillTab === BILL_TAB_HISTORY) {
            fetchPaymentHistory(selectedItem?.CardKey, overrides)
        } else {
            fetchBillersData(selectedItem?.CardKey, overrides)
        }


        // close overlay after apply
        setShowFilterOverlay(false)
        setIsHideSearchAndFilterBtn(true)
    }



    const handleFilterClick = (activeTab) => {
        dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: global.searchValueFromGlobal } });
        setShowFilterOverlay(true);
        setIsHideSearchAndFilterBtn(false)
        logFirebaseEvents("Billers", "filter_Clicked", "filter_Clicked", "", "");
    };

    const onCloseFilter = () => {
        setShowFilterOverlay(false);
        setIsHideSearchAndFilterBtn(true)
        logFirebaseEvents("Billers", "filter_Closed", "filter_Closed", "", "");
    }
   
    // add biller bussiness type and search billere part open click
    const onHandleOpenAddBillerComponet = () => {
        setIsAddBillerComponent(true)
        setIsShowInitialListsCard(false)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(false)
        setMyBillersDetails(false)
    }

    // add billere info part on click
    const openAddbillerInfo = () => {
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(false)
        setIsAddBillerInfo(true)
        setisOpenAddNewBiller(false)
        setMyBillersDetails(false)
    }

    // add new bilere component open click fun
    const handleOpenAddNewBiller =() =>{
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(false)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(true)
        setMyBillersDetails(false)
        fetchCountries()
        fetchStates()
    }

    //cancel add new biller component
    const handleCancelAddNewBiller =() =>{
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(true)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
    }

    // open add new biller submit part open click 
    const handleOpenAddNewBillerSubmit =()=>{
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(false)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(true)
        setMyBillersDetails(false)
    }

    // Open Biller Details Component
    const handleOpenBillerDetailsComponent =()=>{
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(false)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(true)
    }

    // Open Modify biller component
    const handleOpenModifyBiller =()=>{
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(false)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
        setIsOpenModifyBiller(true)
        fetchCountries()
        fetchStates()
    }

    const handleModifBillerSubmitOpen =()=>{
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(false)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
        setIsOpenModifyBiller(false)
        setIsOpenModifyBillerSubmit(true)
    }
 
    //Close Modify biller Component
    const handleCloseModifyBiller =()=>{
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(true)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
        setIsOpenModifyBiller(false)
        setIsOpenModifyBillerSubmit(false)
    }

    // Cancel buttton in Add billers component 
    const onCancelAddBillerButton = () => {
        setIsShowInitialListsCard(true)
        setIsAddBillerComponent(false)
        setIsAddBillerInfo(false)
        setMyBillersDetails(false)
    }

    const closeAddBillerSuccessModal = () => {
        setAddBillerSuccessModal(false)
        setRemoveBillerSuccessOpen(false)
    }

   // addd billere success modal button 1
    const handleSuccessModalButtonOne = () => {
        setIsShowInitialListsCard(false)
        setIsAddBillerComponent(true)
        setIsAddBillerInfo(false)
        setAddBillerSuccessModal(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
        setRemoveBillerSuccessOpen(false)
    }
 // addd billere success modal button 2
    const handleSuccessModalButtonTwo = () => {
        setIsShowInitialListsCard(true)
        setIsAddBillerComponent(false)
        setIsAddBillerInfo(false)
        setAddBillerSuccessModal(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
        setRemoveBillerSuccessOpen(false)
    }

    // modify success Modals close 
    const onCloseModifyBillerSuccessModal = () =>{
        setIsShowInitialListsCard(true)
        setIsAddBillerComponent(false)
        setIsAddBillerInfo(false)
        setAddBillerSuccessModal(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
        setIsOpenModifyBiller(false)
        setIsOpenModifyBillerSubmit(false)
        setModifyBillerSuccessOpen(false);
        
    }
    // modify success Modals close and open add biller
    const onCloseModifySuccessAndOpenAddBiller = () =>{
         setIsShowInitialListsCard(false)
        setIsAddBillerComponent(true)
        setIsAddBillerInfo(false)
        setAddBillerSuccessModal(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
        setIsOpenModifyBiller(false)
        setIsOpenModifyBillerSubmit(false)
        setModifyBillerSuccessOpen(false);
    }

    // Close Details Component
    const closeBillerDetailsComponent = () => {
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(true)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
    }

    // Schedule billers details 
    const closeScheduleBillersDetails = () => {
        setIsAddBillerComponent(false)
        setIsShowInitialListsCard(true)
        setIsAddBillerInfo(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
        setIsOpenScheduleDetails(false)
        setIsOpenModifyBiller(false)
        setIsOpenModifyBillerSubmit(false)
    }

    const handleCloseErrorModal = () => {
        setErrorModal(false)

    }

    const cancelErrorModal = () => {
        setErrorModal(false)
        setIsShowInitialListsCard(true)
        setIsAddBillerComponent(false)
        setIsAddBillerInfo(false)
        setAddBillerSuccessModal(false)
        setisOpenAddNewBiller(false)
        setIsOpenAddNewBillerSubmit(false)
        setMyBillersDetails(false)
        setIsOpenModifyBiller(false)
        setIsOpenModifyBillerSubmit(false)
        setIsOpenScheduleDetails(false)
    }

    const onConfirmRemoveBillerOpen = () =>{
         setRemoveBillerConfirm(true)
    } 

    const handleOpenScheduleBillerRemove = ()=>{
        setRemoveScheduleBiller(true)
    }

    const onOpenModifyBiller = () =>{
        setIsOpenModifyBiller(true)
    }


    const closeRemoveSuccessModal = () => {
        setRemoveBillerConfirm(false)
    }

    const closeScheduleRemoveModal = () => {
        setRemoveScheduleBiller(false)
        setIsShowInitialListsCard(true)
        setIsOpenScheduleDetails(false)
        handleBillPaymentsTabChange(BILL_TAB_PAYEES)
    }

    const handleCallRemoveBiller =()=>{
        removeBiller()
    }

    const handleCancleSchedulePayment = () =>{
       cancelBiller()
    }

    const handleCanclePaymentSecondButton = () => {
        setCancelPaymentSuccessModal(false)
        setIsShowInitialListsCard(true)
        setIsOpenScheduleDetails(false)
    }

   

    const fetchAccounts = async () => {
        try {
            setIsLoading(true);
            const deviceId = await retrieveData('updatedDeviceId')
            const url = GET_ACCOUNTS_FOR_TRANSFER.replace('{CARD_KEY}', selectedItem.CardKey) + '?statusCode=ACT&ach=false'
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                const primaryAccount = responseJson.Response?.Accounts?.find(
                    acc => acc.AccountType === "Primary"
                );
                dispatch({ type: 'PRIMARY_ACCOUNT', payload: { primaryAccount: primaryAccount } });
            }

        } catch (error) {
            setIsLoading(false);
        }
    }
 
    const fetchOverview = async () => {
        try {
            setIsLoading(true);
            const deviceId = await retrieveData('updatedDeviceId')
            const url = BILL_PAYMENTS_OVERVIEW(selectedItem?.CardKey)
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                setOverViewResp(responseJson.Response)
                setBillPaymentFeeMessage(responseJson.Response?.BillPaymentFeeMessage)
            }

        } catch (error) {
            setIsLoading(false);
        }
    }

    const fetchFrequency = async () => {

        try {
            const url = BILL_PAYMENTS_META_DATA(selectedItem.CardKey);
            const deviceId = await retrieveData('updatedDeviceId');
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            setIsLoading(true)
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                const frequencyResp = responseJson.Response.BillPayFrequencies;
                const transFormedFrequency = frequencyResp.map(con => ({
                    Type: con.Code,
                    Name: con.DisplayText
                }))
                setFrequency(transFormedFrequency)
                dispatch({ type: 'BILL_PAYMENTS_META_DATA', payload: { billPaymentsMetaData: responseJson.Response } });
            }

        } catch (error) {
            setIsLoading(false)
        }

    }

    const fetchCountries = async () => {
        try {
            const url = BILLER_COUNTRIES(selectedItem.CardKey);
            const deviceId = await retrieveData('updatedDeviceId');
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            setIsLoading(true)
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                const countryResp = responseJson.Response;
                const transFormedCountries = countryResp.map(con => ({
                    Type: con.ParameterCode,
                    Name: con.DisplayText
                }))
                setCountries(transFormedCountries)
            }

        } catch (error) {
            setIsLoading(false)
        }

    }


   const fetchStates = async () => {
        try {
            const url = BILLERE_STATES(selectedItem.CardKey);
            const deviceId = await retrieveData('updatedDeviceId');
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            setIsLoading(true)
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                const statesResp = responseJson.Response;
                const transFormedStates = statesResp.map(con => ({
                    Type: con.ParameterCode,
                    Name: con.DisplayText
                }))
                setStates(transFormedStates)
            }

        } catch (error) {
            setIsLoading(false)
        }

    }


    const buildBillPaymentsQuery = (override = {}) => {
        const merged = {
            rows,
            page,
            ...override,
        }


        const params = new URLSearchParams();
        params.set('rows', merged.rows ?? 10);
        params.set('page', merged.page ?? 1);


        // Keep `+` readable in query strings (URLSearchParams encodes it as %2B)
        return params.toString().replace(/%2B/g, '+');
    }



   const fetchBillersData = async (cardKey, overrideFilters = {}) => {
        try {
            setIsLoading(true);
            const deviceId = await retrieveData('updatedDeviceId');
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const url = `${GET_MY_BILL_PAYMENTS(cardKey)}?${buildBillPaymentsQuery(overrideFilters)}`
            const response = await GetRequest(url, headers);

            const responseObj = JSON.parse(response);
            if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                const billersresp = responseObj.Response;
                setMyBillersData(billersresp)
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);

        }
    };

    const fetchScheduledBillersData = async (cardKey, overrideFilters = {}) => {
        try {
            setIsLoading(true);
            const deviceId = await retrieveData('updatedDeviceId');
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const url = `${SCHEDULED_BILLERS_LIST(cardKey)}?${buildBillPaymentsQuery(overrideFilters)}`
            const response = await GetRequest(url, headers);
            const responseObj = JSON.parse(response);
            if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                const resp = responseObj.Response || {};
                const scheduleBillersResp = resp.SVABillPayment;
                setScheduleBillersList(scheduleBillersResp)
                setSchedulePager(resp.Pager ?? responseObj.Pager ?? resp.SVABillPayment?.Pager ?? null)
                
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);

        }
    };

      const fetchPaymentHistory = async (cardKey, overrideFilters = {}) => {
        try {
            setIsLoading(true);
            const deviceId = await retrieveData('updatedDeviceId');
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            // History endpoint uses `cardKey` query param in addition to the shared filters
            const base = `/api/cardholders/${cardKey}/bill-payments?cardKey=${cardKey}`
            const url = `${base}&${buildBillPaymentsQuery(overrideFilters)}`
            const response = await GetRequest(url, headers);
            const responseObj = JSON.parse(response);
            if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
           const resp = responseObj.Response || {};
                const paymentHistoryResp = resp.SVABillPayment;
                setPaymentHistoryList(paymentHistoryResp)
                setHistoryPager(resp.Pager ?? responseObj.Pager ?? resp.SVABillPayment?.Pager ?? null)
                
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);

        }
    };



     const handleScheduleViewMore = async () => {
        if (!selectedItem?.CardKey) return
        const nextRows = Number(rows) + 10
        setRowsPerPage(nextRows)
        setPage(1)
        await fetchScheduledBillersData(selectedItem.CardKey, { rows: nextRows, page: 1 })
    }


    const handleHistoryViewMore = async () => {
        if (!selectedItem?.CardKey) return
        const nextRows = Number(rows) + 10
        setRowsPerPage(nextRows)
        setPage(1)
        await fetchPaymentHistory(selectedItem.CardKey, { rows: nextRows, page: 1 })
    }

    const getBillersList = async (searchText) => {
        try {
            setIsLoading(true);
            const deviceId = await retrieveData('updatedDeviceId');
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const response = await GetRequest(
                GET_MASTER_BILLERS(selectedItem?.CardKey, searchText),
                headers
            );
            const responseObj = JSON.parse(response);
            if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                const billersresp = responseObj.Response.ProgramBiller;
                const transFormedBillerTypes = billersresp.map(con => ({
                    Type: con.BillerID,
                    Name: con.BillerName
                }))
                dispatch({ type: 'BILLER_TYPES_LIST', payload: { billerTypesList: transFormedBillerTypes } });

            } else {
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
        }
    };


    const handleAddBillerSubmit = async () => {
        if(!twoFactAuthenticationDone)
        {
            setSlectedFieldToEdit(t('rpps_biller'))
            setSelectedType(t('rpps_biller'))
            setshow2faSelection(true)
            return;
        }
        setIsLoading(true)
       
         const body = {
            "BillerID": selectedBiller?.Type,
            "BillerName": selectedBiller?.Name,
            "AccountNumber": enteredAccountNumber,
            "ReferenceName": "",
            "FrequencyType": selectedFrequencyType?.Type,
            "NextDate": selectedFrequencyType?.Type === "O" ? formatDateYYYYMMDDFORSCH(billPaymentOneTimeDate) : formatDateYYYYMMDDFORSCH(billPaymenRCStartDate),
            "EndDate": selectedFrequencyType?.Type === "O" ? formatDateYYYYMMDDFORSCH(billPaymentOneTimeDate) : formatDateYYYYMMDDFORSCH(billPaymenRCEndDate),
            "Amount": billAmount
        }
        const deviceId = await retrieveData("updatedDeviceId");
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = ADD_RPPS_BILLERS(selectedItem.CardKey)
        try {
            const response = await PostRequest(url, body, headers);
            const responseJson = JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false)
                setAddBillerSuccessModal(true)
                setIsAddBillerComponent(false)
                setIsAddBillerInfo(false)
                setIsShowInitialListsCard(true)
                handleBillPaymentsTabChange(BILL_TAB_PAYEES)
                fetchOverview()
                getBillersList("")

                dispatch({ type: 'SELECTED_BILLER_TYPE', payload: { selectedBillerType: "" } });
                dispatch({ type: 'ENTERED_ACCOUNT_NUMBER', payload: { enteredAccountNumber: "" } });
                dispatch({ type: 'RE_ENTERED_ACCOUNT_NUMBER', payload: { reEnteredAccNumber: "" } });
                dispatch({ type: 'SELECTED_FREQUENCY_TYPE', payload: { selectedFrequencyType: "" } });
                dispatch({ type: 'BILL_AMOUNT', payload: { billAmount: "" } });
                dispatch({ type: 'BILL_PAYMENT_ONE_TIME', payload: { billPaymentOneTimeDate: null } })
                dispatch({ type: 'BILL_PAYMENT_RC_START', payload: { billPaymenRCStartDate: null } })
                dispatch({ type: 'BILL_PAYMENT_RC_END', payload: { billPaymenRCEndDate: null } })

                dispatch({ type: 'NEW_BILLER_NAME', payload: { newBillerName: "" } });
                dispatch({ type: 'NEW_BILLER_ACCOUNT_NUMBER', payload: { newAccountNumber: "" } });
                dispatch({ type: 'BILLER_ADDRESS_ONE', payload: { billerAddressOne: "" } });
                dispatch({ type: 'BILLER_ADDRESS_Two', payload: { billerAddressTwo: "" } });
                dispatch({ type: 'BILLER_ADDRESS_CITY', payload: { billerAddressCity: "" } });
                dispatch({ type: 'BILLER_ADDRESS_ZIPCODE', payload: { billerAddressZipCode: "" } });
                dispatch({ type: 'BILLER_ADDRESS_STATES', payload: { billerAddressStates: "" } });
                dispatch({ type: 'BILLER_ADDRESS_COUNTRIES', payload: { billerAddressCuntries: "" } });
                dispatch({ type: 'BILLER_ADDRESS_PHONE', payload: { billerAddressPhone: "" } });
                dispatch({ type: 'NEW_BILLER_FREQUENCY', payload: { newBillerFrequency: "" } });
                dispatch({ type: 'NEW_BILLER_AMOUNT', payload: { newBillerAmount: "" } });
                dispatch({ type: 'NEW_BILLER_ONE_TIME', payload: { newBillerOneTimeDate: null } });
                dispatch({ type: 'NEW_BILLER_RC_START', payload: { newBillerRcStartDate: null } });
                dispatch({ type: 'NEW_BILLER_RC_END', payload: { newBillerRcEndDate: null } });
            } else {
                var arrMessages = responseJson.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setApiErrMsg(displayText)
                setIsLoading(false)
                setErrorModal(true)

            }
        } catch (error) {
            // setApisErrorModal(true)
            setIsLoading(false)
        }
    }

    const newBillerSubmit = async () => {
         if(!twoFactAuthenticationDone)
        {
            setSlectedFieldToEdit(t('paper_biller'))
            setSelectedType(t('paper_biller'))
            setshow2faSelection(true)
            return;
        }
        setIsLoading(true)
         const body = {
            "BillerName": newBillerName,
            "AccountNumber": newAccountNumber,
            "Amount": newBillerAmount,
            "NextDate": newBillerFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(newBillerOneTimeDate) : formatDateYYYYMMDDFORSCH(newBillerRcStartDate),
            "EndDate": newBillerFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(newBillerOneTimeDate) : formatDateYYYYMMDDFORSCH(newBillerRcEndDate),
            "FrequencyType": newBillerFrequency?.Type,
            "Line1": billerAddressOne,
            "Line2": billerAddressTwo,
            "City": billerAddressCity,
            "StateCode": billerAddressStates?.Type,
            "CountryCode": billerAddressCuntries?.Type,
            "ZipCode": billerAddressZipCode,
            "PhoneNumber": billerAddressPhone
        }

        const deviceId = await retrieveData("updatedDeviceId");
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = ADD_PAPER_BILLER(selectedItem.CardKey)
        try {
            const response = await PostRequest(url, body, headers);
            const responseJson = JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false)
                setAddBillerSuccessModal(true)
                handleBillPaymentsTabChange(BILL_TAB_PAYEES)
                setIsShowInitialListsCard(true)
                setisOpenAddNewBiller(false)
                setIsOpenAddNewBillerSubmit(false)
                fetchOverview()
                getBillersList("")

                dispatch({ type: 'SELECTED_BILLER_TYPE', payload: { selectedBillerType: "" } });
                dispatch({ type: 'ENTERED_ACCOUNT_NUMBER', payload: { enteredAccountNumber: "" } });
                dispatch({ type: 'RE_ENTERED_ACCOUNT_NUMBER', payload: { reEnteredAccNumber: "" } });
                dispatch({ type: 'SELECTED_FREQUENCY_TYPE', payload: { selectedFrequencyType: "" } });
                dispatch({ type: 'BILL_AMOUNT', payload: { billAmount: "" } });
                dispatch({ type: 'BILL_PAYMENT_ONE_TIME', payload: { billPaymentOneTimeDate: null } })
                dispatch({ type: 'BILL_PAYMENT_RC_START', payload: { billPaymenRCStartDate: null } })
                dispatch({ type: 'BILL_PAYMENT_RC_END', payload: { billPaymenRCEndDate: null } })


                dispatch({ type: 'NEW_BILLER_NAME', payload: { newBillerName: "" } });
                dispatch({ type: 'NEW_BILLER_ACCOUNT_NUMBER', payload: { newAccountNumber: "" } });
                dispatch({ type: 'BILLER_ADDRESS_ONE', payload: { billerAddressOne: "" } });
                dispatch({ type: 'BILLER_ADDRESS_Two', payload: { billerAddressTwo: "" } });
                dispatch({ type: 'BILLER_ADDRESS_CITY', payload: { billerAddressCity: "" } });
                dispatch({ type: 'BILLER_ADDRESS_ZIPCODE', payload: { billerAddressZipCode: "" } });
                dispatch({ type: 'BILLER_ADDRESS_STATES', payload: { billerAddressStates: "" } });
                dispatch({ type: 'BILLER_ADDRESS_COUNTRIES', payload: { billerAddressCuntries: "" } });
                dispatch({ type: 'BILLER_ADDRESS_PHONE', payload: { billerAddressPhone: "" } });
                dispatch({ type: 'NEW_BILLER_FREQUENCY', payload: { newBillerFrequency: "" } });
                dispatch({ type: 'NEW_BILLER_AMOUNT', payload: { newBillerAmount: "" } });
                dispatch({ type: 'NEW_BILLER_ONE_TIME', payload: { newBillerOneTimeDate: null } });
                dispatch({ type: 'NEW_BILLER_RC_START', payload: { newBillerRcStartDate: null } });
                dispatch({ type: 'NEW_BILLER_RC_END', payload: { newBillerRcEndDate: null } });
            } else {
                var arrMessages = responseJson.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setApiErrMsg(displayText)
                setIsLoading(false)
                setErrorModal(true)

            }
        } catch (error) {
            // setApisErrorModal(true)
            setIsLoading(false)
        }
    }

    const removeBiller = async () => {
        setIsLoading(true)
         const body = {
            "SVABillerKey":billerKey
        }
        const deviceId = await retrieveData("updatedDeviceId");
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = REMOVE_BILLERE(selectedItem?.CardKey)
        try {
            const response = await PostRequest(url, body, headers);
            const responseJson = JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false)
                setRemoveBillerConfirm(false)
                setRemoveBillerSuccessOpen(true)
                handleBillPaymentsTabChange(BILL_TAB_PAYEES)
                fetchOverview()
                getBillersList("")

            } else {
                var arrMessages = responseJson.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setApiErrMsg(displayText)
                setRemoveBillerConfirm(false)
                setIsLoading(false)
                setErrorModal(true)

            }
        } catch (error) {
            // setApisErrorModal(true)
            setIsLoading(false)
        }
    }


    const cancelBiller = async () => {
        setIsLoading(true)
         const body = {
            "SVAPaymentKey":cancelPaymentKey
        }
        const deviceId = await retrieveData("updatedDeviceId");
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = CANCEL_PAYMENT(selectedItem.CardKey)
        try {
            const response = await PostRequest(url, body, headers);
            const responseJson = JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false)
                setRemoveScheduleBiller(false)
                setCancelPaymentSuccessModal(true)
                fetchOverview()
                handleBillPaymentsTabChange(BILL_TAB_PAYEES)
                // fetchScheduledBillersData(selectedItem.CardKey)
                getBillersList("")

            } else {
                var arrMessages = responseJson.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setApiErrMsg(displayText)
                setIsLoading(false)
                setRemoveScheduleBiller(false)
                setErrorModal(true)

            }
        } catch (error) {
            // setApisErrorModal(true)
            setIsLoading(false)
        }
    }

    // Biller Details 
    const getBillersDetails = async (data) => {
        try {
          setIsLoading(true);
           seBillerTypeForDetails(data?.BillerType ?? null)
          const deviceId = await retrieveData('updatedDeviceId');
          const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
          const response = await GetRequest(
            GET_BILLER_DETAILS(selectedItem.CardKey, data?.SVABillerKey),
            headers
          );

          const responseObj = JSON.parse(response);
          if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
            const responceObject = responseObj.Response;
            setBillerDetailsResp(responceObject)
            setIsLoading(false);

              setIsAddBillerComponent(false)
              setIsShowInitialListsCard(false)
              setIsAddBillerInfo(false)
              setisOpenAddNewBiller(false)
              setIsOpenAddNewBillerSubmit(false)
              setMyBillersDetails(true)
              setIsOpenModifyBiller(false)
              setIsOpenModifyBillerSubmit(false)
          
          } else {
            setIsLoading(false);
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
          }
        } catch (error) {
          setIsLoading(false);
          return [];
        }
    };


    //Schedule Details API Call
    const getScheduleBillerDetails = async (data) => {
        try {
          setIsLoading(true);
          const deviceId = await retrieveData('updatedDeviceId');
          const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
          const response = await GetRequest(
            SCHEDULED_DETAILES(selectedItem.CardKey, data?.SVAPaymentKey),
            headers
          );

          const responseObj = JSON.parse(response);
          if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
            const responceObject = responseObj.Response;
             setScheduleBillersDetailsResp(responceObject)
             setIsLoading(false);

              setIsAddBillerComponent(false)
              setIsShowInitialListsCard(false)
              setIsAddBillerInfo(false)
              setisOpenAddNewBiller(false)
              setIsOpenAddNewBillerSubmit(false)
              setMyBillersDetails(false)
              setIsOpenModifyBiller(false)
              setIsOpenModifyBillerSubmit(false)
              setIsOpenScheduleDetails(true)
          
          } else {
            setIsLoading(false);
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
          }
        } catch (error) {
          setIsLoading(false);
          return [];
        }
    };

     // Biller Details for Modify biler
    const getBillersDetailsForModifyBiller = async (data) => {
        try {
          setIsLoading(true);
           setModifyBillerType(data?.BillerType ?? null)
          const deviceId = await retrieveData('updatedDeviceId');
          const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
          const response = await GetRequest(
            GET_BILLER_DETAILS(selectedItem.CardKey, data?.SVABillerKey),
            headers
          );

          const responseObj = JSON.parse(response);
          if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
            const responceObject = responseObj.Response;
            setBillerDetailsResp(responceObject)
            setIsLoading(false);
          
          } else {
            setIsLoading(false);
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
          }
        } catch (error) {
          setIsLoading(false);
          return [];
        }
    };


    useEffect(() => {


        // Search/filter query params removed for bill payments.




        fetchBillersData(selectedItem.CardKey)
        // fetchScheduledBillersData(spendingCard.CardKey)
        // fetchPaymentHistory(spendingCard.CardKey)
        getBillersList("")
        fetchAccounts()
        fetchFrequency()
        fetchOverview()
        dispatch({ type: 'SELECTED_BILLER_TYPE', payload: { selectedBillerType: "" } });
        dispatch({ type: 'ENTERED_ACCOUNT_NUMBER', payload: { enteredAccountNumber: "" } });
        dispatch({ type: 'RE_ENTERED_ACCOUNT_NUMBER', payload: { reEnteredAccNumber: "" } });
        dispatch({ type: 'SELECTED_FREQUENCY_TYPE', payload: { selectedFrequencyType: "" } });
        dispatch({ type: 'BILL_AMOUNT', payload: { billAmount: "" } });
        dispatch({ type: 'BILL_PAYMENT_ONE_TIME', payload: { billPaymentOneTimeDate: null } })
        dispatch({ type: 'BILL_PAYMENT_RC_START', payload: { billPaymenRCStartDate: null } })
        dispatch({ type: 'BILL_PAYMENT_RC_END', payload: { billPaymenRCEndDate: null } })
         

        //New Biller states
        dispatch({ type: 'NEW_BILLER_NAME', payload: { newBillerName: "" } });
        dispatch({ type: 'NEW_BILLER_ACCOUNT_NUMBER', payload: { newAccountNumber: "" } });
        dispatch({ type: 'BILLER_ADDRESS_ONE', payload: { billerAddressOne: "" } });
        dispatch({ type: 'BILLER_ADDRESS_Two', payload: { billerAddressTwo: "" } });
        dispatch({ type: 'BILLER_ADDRESS_CITY', payload: { billerAddressCity: "" } });
        dispatch({ type: 'BILLER_ADDRESS_ZIPCODE', payload: { billerAddressZipCode: "" } });
        dispatch({ type: 'BILLER_ADDRESS_STATES', payload: { billerAddressStates: "" } });
        dispatch({ type: 'BILLER_ADDRESS_COUNTRIES', payload: { billerAddressCuntries: "" } });
        dispatch({ type: 'BILLER_ADDRESS_PHONE', payload: { billerAddressPhone: "" } });
        dispatch({ type: 'NEW_BILLER_FREQUENCY', payload: { newBillerFrequency: "" } });
        dispatch({ type: 'NEW_BILLER_AMOUNT', payload: { newBillerAmount: "" } });
        dispatch({ type: 'NEW_BILLER_ONE_TIME', payload: { newBillerOneTimeDate: null } });
        dispatch({ type: 'NEW_BILLER_RC_START', payload: { newBillerRcStartDate: null } });
        dispatch({ type: 'NEW_BILLER_RC_END', payload: { newBillerRcEndDate: null } });
    }, [])


    
    
    const handleModifyBillerSuccess = (responseJson) => {
       
        if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
            setModifyBillerSuccessOpen(true)
            handleBillPaymentsTabChange(BILL_TAB_PAYEES)
            getBillersList("")
        } else {
                var arrMessages = responseJson.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setApiErrMsg(displayText)
                setErrorModal(true)

        }

    }


    const handleSubmitSearch = (value, tabLabel) => {
        const tab = tabLabel ?? activeBillTab
        const search = value ?? ''
        // Keep redux + global in sync for query builder
        global.searchValueFromGlobal = search
        dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: search } })

        if (!selectedItem?.CardKey) return

        const overrides = {
            search,
            page: 1,
            rows,
        }

        if (tab === BILL_TAB_PAYEES) {
            fetchBillersData(selectedItem?.CardKey, overrides)
        } else if (tab === BILL_TAB_SCHEDULE) {
            fetchScheduledBillersData(selectedItem.CardKey, overrides)
        } else if (tab === BILL_TAB_HISTORY) {
            fetchPaymentHistory(selectedItem.CardKey, overrides)
        }
    }

   const handleBillPaymentsTabChange = (tab) => {
        setActiveBillTab(tab)
        if (!selectedItem?.CardKey) return
        const overrides = getInitialFilterOverrides()
        handleResetFilters()

        if (tab === BILL_TAB_PAYEES) {
            fetchBillersData(selectedItem?.CardKey, overrides)
        } else if (tab === BILL_TAB_SCHEDULE) {
            fetchScheduledBillersData(selectedItem?.CardKey, overrides)
        } else if (tab === BILL_TAB_HISTORY) {
            fetchPaymentHistory(selectedItem?.CardKey, overrides) 
        }
    }

const shouldShowBillPaymentsFooter =
    isShowIntialListsCard &&
    (
        (activeBillTab === BILL_TAB_HISTORY &&
            Number(historyPager?.TotalItems ?? 0) > Number(rows)) ||
        (activeBillTab === BILL_TAB_SCHEDULE &&
            Number(schedulePager?.TotalItems ?? 0) > Number(rows))
    );

    return (
        <>
            <HomeLayout>
                <HomeHeader heading="" isHeaderCaption={false} selectedIndex={1} />
                <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight  '>
                    <DynamicCard
                        header={false}
                        footer={!shouldShowBillPaymentsFooter}
                        footerContent={<Footer />}
                        CardRadius={true}
                        HeaderRadius={true}
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        cardWidth={width.homeCardWithFilters}
                         cardHeight='content-fit'
                        isBillPayHeaderBg={kudzuPlusTrue || !isShowIntialListsCard ? false : true}
                        backgroundColor={'--billpay-cardHeading-bg'}
                        HeaderContent={
                            <>
                                <div className="relative">
                                    <div className="flex flex-row justify-between mx-10 my-6 md:m-10">
                                        <div className="flex flex-row gap-2 items-center ">
                                            <p className='ml-11 font-hanken-grotesk font-[600] text-[var(--notificationItem-color)] text-[16px] leading-[26px] sm:text-[15px] sm:leading-[23px] md:font-[500] md:text-[26px] md:leading-[36px]'>{t("BILL_PAYMENTS")}</p>
                                        </div>
                                        <div className="sm:w-[190px] md:w-[154px] lg:w-[200px] w-[20%] cursor-pointer">
                                            {isShowIntialListsCard &&
                                                <button
                                                    type="button"
                                                    className={`font-hanken-grotesk lg:text-[15px] md:text-[14px] sm:text-[12px] text-[13px] md:leading-[39.71px] sm:leading-[25.8px] 
                                                               md:h-[50px] sm:h-[36px] h-[40px] inline-block rounded-full 
                                                               border-[3px] ${kudzuPlusTrue ? 'border-[#4B70B9] text-[#ffffff]' : 'border-[#2965FB] text-[#2965FB]' } 
                                                               text-xs font-semibold leading-normal text-success 
                                                               transition duration-150 ease-in-out sm:w-[100%]`}
                                                    data-te-ripple-init
                                                    onClick={onHandleOpenAddBillerComponet}
                                                >
                                                    {t("BILL_PAYMENTS_ADD_BILLER")}
                                                </button>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    >

                        {isShowIntialListsCard &&
                            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
          animate__animated animate__fadeInRight '>
                                <div className='md:w-[100%] sm:w-[100%] w-full md:pt-10 pt-10'>
                                    {!showFilterOverlay &&
                                    <Tabs
                                        selectedTab={activeBillTab}
                                        onFilterClick={() => {}}
                                        updateActiveTab={handleBillPaymentsTabChange}
                                        isEnabled={true}
                                        billPayments={true}
                                        hideSearchAndFilterBtn={true}
                                    >
                                        <Tab label={BILL_TAB_PAYEES} count={overviewResp?.BillerCount} message={billPaymentFeeMessage}>
                                            { myBiillersData && myBiillersData.length > 0 ? (
                                                <>
                                                      {myBiillersData.map((data) => (
                                                <BillersData key={data.id} 
                                                transactionData={data} 
                                                redirectToBillerDetails={getBillersDetails}  
                                                openRemoveBiller={onConfirmRemoveBillerOpen} 
                                                openModifyBiller={handleOpenModifyBiller}
                                                details={getBillersDetailsForModifyBiller}
                                                />
                                            ))}
                                            </>
                                            ):(
                                                        <>
                                                            <div
                                                                className={`${footerStylesNoRecords} text-left text-[#4B70B9]`}
                                                            >
                                                                {t('No bill payment to report! Check back here after your bill pay!')}
                                                            </div>
                                                        </>
                                            )}
                                           
                                       
                                        </Tab>
                                        <Tab label={BILL_TAB_SCHEDULE} count={overviewResp?.ScheduledBillPaymentCount} message={billPaymentFeeMessage}>
                                                {scheduleBillersList && scheduleBillersList.length > 0 ?
                                                    (<>
                                                        {scheduleBillersList.map((data) => (
                                                            <ScheduleBillersData key={data.id}
                                                                transactionData={data}
                                                                redirectToScheduleDetailsDetails={getScheduleBillerDetails}
                                                            />
                                                        ))}
                                                    </>) :(
                                                        <>
                                                            <div
                                                                className={`${footerStylesNoRecords} text-left text-[#4B70B9]`}
                                                            >
                                                                {t('No bill payment history to report! Check back here after your bill pay!')}
                                                            </div>
                                                        </>
                                                        )
                                                }
                                             
                                        </Tab>
                                            <Tab label={BILL_TAB_HISTORY}  message={billPaymentFeeMessage}>
                                                {paymentHistoryList && paymentHistoryList.length > 0 ? (
                                                    <>
                                                        {paymentHistoryList.map((data) => (
                                                            <PaymentHistoryData key={data.id}
                                                                transactionData={data}

                                                            />
                                                        ))}

                                                    </>
                                                ) : (
                                                    <>
                                                        <div
                                                            className={`${footerStylesNoRecords} text-left text-[#4B70B9]`}
                                                        >
                                                            {t('No bill payment to report! Check back here after your bill pay!')}
                                                        </div>
                                                    </>)}

                                            </Tab>
                                    </Tabs>}


                                    {
                                       false &&
                                        (
                                            <FilterSlider
                                                selectedTab={""}
                                                applyFilters={handleApplyFilters}
                                                filterClose={onCloseFilter}
                                                handleReset={handleResetFilters}
                                                appliedFilters={{
                                                    debit: true,
                                                    credit: true,
                                                // Filters disabled for now; keep placeholders to avoid relying on removed state.
                                                minAmnt: '0',
                                                maxAmnt: '500+',
                                                minDate: '',
                                                maxDate: '',
                                                }}
                                                hideTabsAndsearch={true} />




                                        )

                                    }
                                </div>
                            </div>
                        }

                        {(isAddBillerComponentOpen || isOpenAddBillerInfo) && (
                            <AddBiller
                                onSearchBiller={(searchText) => {
                                    getBillersList(searchText);
                                }}
                                onNextClick={openAddbillerInfo}
                                onCancelClick={onCancelAddBillerButton}
                                addBillerList={isAddBillerComponentOpen}
                                addBillerInfo={isOpenAddBillerInfo}
                                frequency={frequency}
                                addBillerSubbmit={handleAddBillerSubmit}
                                addNewBiller={handleOpenAddNewBiller}
                            />
                        )}

                        {(isOpenAddNewBiller || isOpenAddNewBillerSubmit) &&
                        <>
                        <AddNewBiller 
                           getStates={states} 
                           getCountries={countries}
                           onCancelButton={handleCancelAddNewBiller}
                           onOpenSubmitBiller={handleOpenAddNewBillerSubmit}
                           newBiller={isOpenAddNewBiller}
                           submitBiller={isOpenAddNewBillerSubmit}
                           frequency={frequency}
                           submitNewBillerRequest={newBillerSubmit}
                           />
                        </>
                        }
                        {myBillerDetails &&
                           <BillerDetails  billerTypeToModify={billerTypeForDetails} data={billereDetailsResp} onClose={closeBillerDetailsComponent}/>
                        }

                        {(isOpenModifyBiller || isOpenModifyBillerSubmit) && 
                          <ModifyBiller 
                           billerTypeToModify={modifyBillerType}
                          data={billereDetailsResp} 
                          onCancel={handleCloseModifyBiller} 
                          frequency={frequency} 
                          modifyBiller={isOpenModifyBiller}
                          modifySubmitBiller={isOpenModifyBillerSubmit}
                          openSubmitPart={handleModifBillerSubmitOpen}
                          getStates={states} 
                          getCountries={countries}
                          setIsLoading={setIsLoading}
                          onModifySuccess={handleModifyBillerSuccess}
                          onRequireModifyBiller2FA={handleRequireModifyBiller2FA}
                          />
                          
                        }

                        {isOpenScheduleDetails &&
                           <ScheduleBillerDetails data={scheduleBillersDetailsResp} onClose={closeScheduleBillersDetails} removeScheduleBiller={handleOpenScheduleBillerRemove}/>
                        }
                    </DynamicCard>
                </div>
            </HomeLayout>


            <Modal
                isOpen={isOTPVerifyModalOpen}
                onClose={closeOTPVerifyModal}
                isLogo={false}
                title={<p className={HighlightMsgStyles}> {twoFactModelTitle}</p>}
                subtitle={<><p className={HeaderMsgStyles}>{twoFactModelSubTitle}</p> {showStnadradRatesMessage && <p className="font-hanken-grotesk my-3 text-[var(--text-clr-transactions)]  lg:text-[20px] md:text-[18px] sm:text-[15px] text-[18px] leading-[30px] font-[500]  w-full">{t('standrd_message_rates_apply')}</p>}</>}
                content={<div className="mt-10"><Custom2FA selected2FAType={selectedOtpType} type={selectedType} onClose={closeOTPVerifyModal} verificationFailure={verificationFaiure} verificationSuccess={verificationSuccess} bottomText={bottomTextValue} /></div>}
            />


          {/* 2 FA  selection modal */}
            <TwoFactTypeSelctionModal isOpen={show2faSelection} onClose={() => { setshow2faSelection(false) }}
                onClickNext={(object) => {
                    setshow2faSelection(false);
                    setSelectedOtpType(object.proc)
                    if (slectedFieldToEdit == t('rpps_biller')) {
                           generate2FAOtp(t('rpps_biller'), object.proc);
                    }
                    if (slectedFieldToEdit == t('paper_biller')) {
                            generate2FAOtp(t('paper_biller'), object.proc);
                    }
                     if (slectedFieldToEdit == t('modify_paper')) {
                            generate2FAOtp(t('modify_paper'), object.proc);
                    }
                      if (slectedFieldToEdit == t('modify_rpps')) {
                            generate2FAOtp(t('modify_rpps'), object.proc);
                    }


                }} />


            <Modal
                isOpen={addBillerSuccessModal}
                onClose={(e) => {
                    setAddBillerSuccessModal(false);
                    setisOpenAddNewBiller(false)
                    setIsAddBillerInfo(false)
                    setisOpenAddNewBiller(false)
                    setIsOpenAddNewBillerSubmit(false)
                    setIsOpenModifyBiller(false)
                    setIsShowInitialListsCard(true)
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    <p className={`${HeadingStyles} hidden sm:flex`}>
                        {t("Success!")}
                    </p>
                }
                subtitle={
                    <p>
                        <span className={SubHeadingStyles}>{t('Your biller has been added successfully.')}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253  sm:mt-6 mt-6">
                        <AddBillersSuccessModal ModalClose={closeAddBillerSuccessModal} btnOne={handleSuccessModalButtonOne} btnTwo={handleSuccessModalButtonTwo} />
                    </div>
                }
            />


            <Modal
                isOpen={errorModal}
                onClose={(e) => {
                    setErrorModal(false);
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    <p className={`${HeadingStyles} hidden sm:flex`}>
                        {t("oops_exclamation")}
                    </p>
                }
                subtitle={
                    <p>
                        <span className={`${HeadingStyles} visible sm:hidden`}>
                            {t("oops_exclamation")}
                        </span>
                        <span className={SubHeadingStyles}>{apiErrMsg}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                        <ErrorModal ModalClose={handleCloseErrorModal} showMainText={false} btnOne={handleCloseErrorModal} btnTwo={cancelErrorModal} />
                    </div>
                }
            />

            {/* Remove billere Confirmation modal */}
            <Modal
                isOpen={removeBillerConfirm}
                onClose={(e) => {
                    setRemoveBillerConfirm(false);
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    // <p className={`${HeadingStyles} hidden sm:flex`}>
                    //     {t("Success!")}
                    // </p>
                    <></>
                }
                subtitle={
                    <p>
                        <span className={SubHeadingStyles}>{t('REMOVE_BILLER_HEADING')}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253  sm:mt-6 mt-6">
                        <RemoveBiller ModalClose={closeRemoveSuccessModal} btnOne={handleCallRemoveBiller} btnTwo={closeRemoveSuccessModal} />
                    </div>
                }
            />


            {/* Remove Biller Success Modal */}
            <Modal
                isOpen={removeBillerSucessOpen}
                onClose={(e) => {
                    setRemoveBillerSuccessOpen(false)
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    <p className={`${HeadingStyles} hidden sm:flex`}>
                        {t("Success!")}
                    </p>
                }
                subtitle={
                    <p>
                        <span className={SubHeadingStyles}>{t('Your biller has been removed successfully.')}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253  sm:mt-6 mt-6">
                        <AddBillersSuccessModal ModalClose={closeAddBillerSuccessModal} btnOne={handleSuccessModalButtonOne} btnTwo={handleSuccessModalButtonTwo} />
                    </div>
                }
            />

             {/*Modify biller success modal */}
            <Modal
                isOpen={modifySuccessBillerOpen}
                onClose={(e) => {
                    setModifyBillerSuccessOpen(false);
                    setIsOpenModifyBiller(false);
                    setIsOpenModifyBillerSubmit(false)
                    setIsShowInitialListsCard(true)
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    <p className={`${HeadingStyles} hidden sm:flex`}>
                        {t("Success!")}
                    </p>
                }
                subtitle={
                    <p>
                        <span className={SubHeadingStyles}>{t('Your biller has been modified successfully.')}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253  sm:mt-6 mt-6">
                        <AddBillersSuccessModal ModalClose={onCloseModifyBillerSuccessModal} btnOne={onCloseModifySuccessAndOpenAddBiller} btnTwo={onCloseModifyBillerSuccessModal}  />
                    </div>
                }
            />


            <Modal
                isOpen={removeScheduleBiller}
                onClose={(e) => {
                    setRemoveScheduleBiller(false);
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    // <p className={`${HeadingStyles} hidden sm:flex`}>
                    //     {t("Success!")}
                    // </p>
                    <></>
                }
                subtitle={
                    <p>
                        <span className={SubHeadingStyles}>{t('DELETE_SCHEDULED_PAYMENT_HEADING')}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253  sm:mt-6 mt-6">
                        <RemoveBiller ModalClose={closeScheduleRemoveModal} btnOne={handleCancleSchedulePayment} btnTwo={closeScheduleRemoveModal} showSubHeading={true} />
                    </div>
                }
            />


            {/* Cancel Payment Success Modal */}
            <Modal
                isOpen={cancelPaymentSuccessModal}
                onClose={(e) => {
                    setCancelPaymentSuccessModal(false);
                    setIsShowInitialListsCard(true)
                    setIsOpenScheduleDetails(false)
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                   <></>

                }
                subtitle={
                    <p>
                        <span className={SubHeadingStyles}>{t('DELETE_SUCCESS_TEXT')}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253  sm:mt-6 mt-6">
                        <AddBillersSuccessModal ModalClose={handleCanclePaymentSecondButton}  btnTwo={handleCanclePaymentSecondButton} showBtnOne={true}/>
                    </div>
                }
            />

            {isLoading && <Loader />}
        </>
    )
}
export default withOidcSecure(BillPayments);